import { QualityEventCreate } from '../types';
import { useCurrentUser, useToastProvider } from '@qualio/ui-components';
import { useMutation } from 'react-query';
import { AxiosError } from 'axios';
import eventsApi from '../api/events.api';
import { extractMessageFromError } from '../utils/errorUtils';

export const useUpdateEvent = (eventId: number) => {
  const { companyId } = useCurrentUser();
  const { showToast } = useToastProvider();

  const {
    mutateAsync: updateEventMutate,
    isLoading: isEventUpdateLoading,
    isSuccess,
  } = useMutation(
    (payload: QualityEventCreate): Promise<void> => {
      return eventsApi.updateViaMedtech(companyId, eventId, payload);
    },
    {
      onError: (error: AxiosError) => {
        const errorMessage = extractMessageFromError(error);
        showToast({
          title: 'Event update failed',
          description: errorMessage,
          status: 'error',
        });
      },
    },
  );

  return { updateEventMutate, isEventUpdateLoading, isSuccess };
};
